import React, { Fragment } from 'react';
import Header from './common/header-component/header';
import Sidebar from './common/sidebar-component/sidebar';
import Footer from './common/footer';
// import { ToastContainer } from "react-toastify";
import { HelmetProvider } from 'react-helmet-async';

const AppLayout = (props) => {
  return (
    <HelmetProvider>
      <Fragment>
        <div className="page-wrapper">
          <div className="page-body-wrapper">
            <Header />
            <Sidebar />
            <div className="page-body mb-4">{props.children}</div>
            <div>
              <Footer />
            </div>
          </div>
        </div>
        {/* <ToastContainer theme="colored" /> */}
      </Fragment>
    </HelmetProvider>
  );
};

export default AppLayout;
